import { Component } from '@angular/core';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-interface-for-all',
  templateUrl: './interface-for-all.component.html',
  styleUrls: ['./interface-for-all.component.scss']
})
export class InterfaceForAllComponent{

  constructor(public baseService: BaseService) {
  }
}
